import { ImageName } from "@mcleod/images";
import { Button, ButtonVariant, ClickEvent, Component, DropdownItem, Label, Layout, Panel, SlideoutDecorator, Snackbar, Toast } from "@mcleod/components";
import { AutogenLayoutCreateCarrier } from "./autogen/AutogenLayoutCreateCarrier";
import { Api, HorizontalAlignment, Navigation, StringUtil } from "@mcleod/core";
import { AddCarrier } from "./AddCarrier";

export class CreateCarrier extends AutogenLayoutCreateCarrier {
    static _showCarrierScreenLink: boolean;
    buttonAdd: Component | Component[];

    override onLoad(): void | Promise<void> {
        this.textboxTypeOfNumber.selectedItem = new DropdownItem("MC Number", "MC Number");
    }

    private buttonSave = new Button({
        rowBreak: false,
        backgroundColor: "primary",
        color: "primary.reverse",
        caption: "Add Carrier",
        borderWidth: 0,
        borderColor: "primary",
        onClick: (event: ClickEvent) => this.createCarrierFromVendor()
    })

    static showSlideout(vendorId: string, carrierName: string, carrierType: string, carrierNumber: string, showCarrierScreenLink: boolean) {
        this._showCarrierScreenLink = showCarrierScreenLink;

        const layout = Layout.getLayout("lme/dispatch/CreateCarrier", {
            vendorId: vendorId, carrierName: carrierName, carrierIdentifier: carrierType, carrierNumber: carrierNumber
        } as any) as CreateCarrier;

        const slideoutDecorator = new SlideoutDecorator({
            title: "Create Carrier from " + getVendorName(vendorId),
            layout: layout,
            fillVerticalSpace: true,
            width: 1000,
            overlayProps: { greyedBackground: true },
            addlComponents: layout.buttonSave,
            onClose: (cancelled: boolean) => layout.slideOut()
        });
    }

    createCarrierFromVendor() {
        this.buttonSave.busy = true;
        const numberType: string = this.textboxTypeOfNumber.text;
        const carrierNumber: string = this.textboxNumber.text;
        const showCarrierScreenLink = CreateCarrier._showCarrierScreenLink;
        if (StringUtil.isEmptyString(numberType) || StringUtil.isEmptyString(carrierNumber)) {
            this.buttonSave.busy = false;
            Snackbar.showWarningSnackbar("MC number or DOT number is required to add carrier from vendor. ");
        } else {
            Api.post("lme/powerbroker/search-carrier-exist",
            {
                "identifier_type": numberType,
                "identifier_number": carrierNumber,
            }).then(response => {
                if (response?.data[0]?.carrier_exist) {
                    this.buttonSave.busy = false;
                    const carrierId = response?.data[0]?.carrier_id;
                    Snackbar.showWarningSnackbar("Carrier " + carrierId + " already exists.");
                } else {
                    Api.post("lme/dispatch/add-carrier",
                        {
                            "carrier_name": "",
                            "carrier_type": numberType,
                            "carrier_identifier": carrierNumber,
                            "packet_contact_name": "",
                            "email_address": ""
                        })
                        .then(response => {
                            this.buttonSave.busy = false;
                            if (StringUtil.isEmptyString(response?.data[0]?.add_carrier_error_message)) {
                                const carrierName = response?.data[0]?.add_carrier_response?.carrier_name;
                                const carrierId = response?.data[0]?.add_carrier_response?.carrier_id;
                                const vendorName = response?.data[0]?.add_carrier_response?.vendor_name;
                                const carrierAddedMessage = "Carrier, " + carrierName + " (" + carrierId + ") " + "has been added. ";
                                const carrierMonitoredMessage = "Carrier is now being monitored with " + vendorName + ".";

                                this.slideOut().then(() => {
                                    if (showCarrierScreenLink) {
                                        Toast.showToast(this.createSuccessToastPanelWithCarrierScreenLink(carrierAddedMessage,carrierMonitoredMessage, carrierId), {backgroundColor: "primary"}, { millisUntilDismissal: 10000 });
                                    } else {
                                        Toast.showToast(this.createSuccessToastPanel(carrierAddedMessage,carrierMonitoredMessage, carrierId), {backgroundColor: "primary"}, { millisUntilDismissal: 10000 });
                                    }
                                });
                                if (!showCarrierScreenLink) {
                                    Navigation.navigateTo("lme/dispatch/Carrier?mode=update&key=" + carrierId, {newTab: false});
                                }

                            } else {
                                Snackbar.showWarningSnackbar("There was an unexpected error adding the carrier.");
                            }
                        }).catch(error => {
                            this.buttonSave.busy = false;
                            Snackbar.showWarningSnackbar("There was an unexpected error adding the carrier - " + error);
                        });
                    }
            });
        }
    }

     createSuccessToastPanelWithCarrierScreenLink(carrierAddedMessage: string,carrierMonitoredMessage: string, carrierId: string) : Panel{
        const labelProps = { color: "white", fontSize: "xlarge", rowBreak: false, paddingLeft: 3, paddingRight: 1, marginLeft: 0, marginRight: 0, wrap: false };
        return new Panel({
            align: HorizontalAlignment.CENTER, fillRow: true,
            components: [
                new Label({ ...labelProps, text:  carrierAddedMessage , rowBreak: true}),
                new Label({ ...labelProps, text:  carrierMonitoredMessage , rowBreak: false}),
                new Button({ imageName: ImageName.detail, imageWidth:20, imageHeight:20, margin: 0, tooltip: "Click to go to Carrier screen", color: "subtle.light", variant: ButtonVariant.round,
                    onClick: () => this.viewCarrierLinkOnClick(carrierId), rowBreak:false})
            ]
        });
    }

    createSuccessToastPanel(carrierAddedMessage: string,carrierMonitoredMessage: string, carrierId: string) : Panel{
        const labelProps = { color: "white", fontSize: "xlarge", rowBreak: false, paddingLeft: 3, paddingRight: 1, marginLeft: 0, marginRight: 0, wrap: false };
        return new Panel({
            align: HorizontalAlignment.CENTER, fillRow: true,
            components: [
                new Label({ ...labelProps, text:  carrierAddedMessage , rowBreak: true}),
                new Label({ ...labelProps, text:  carrierMonitoredMessage , rowBreak: false})
            ]
        });
    }

    viewCarrierLinkOnClick(carrierCode: string) {
        AddCarrier.navigateTo(carrierCode, true);
    }

 }

function getVendorName(vendorId: string) {
    if (vendorId === 'R') {
        return "RMIS";
    } else if (vendorId === 'H') {
        return "Highway";
    } else if (vendorId === 'D') {
        return "MyCarrierPortal";
    } else {
        return "Carrier Insurance Vendor";
    }
}
